import type { ReactNode } from "react";
import { SiteHeader } from "./site-header";
import { SideRail } from "./side-rail";

export function PageShell({
  children,
  overHero = false,
}: {
  children: ReactNode;
  overHero?: boolean;
}) {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader overHero={overHero} />
      <main>{children}</main>
      <SideRail />
    </div>
  );
}

export function ComingSoon({ title, description }: { title: string; description?: string }) {
  return (
    <PageShell>
      <section className="relative overflow-hidden px-6 pb-32 pt-48 md:px-12 md:pb-48 md:pt-56">
        <span className="watermark pointer-events-none absolute -right-4 top-32 select-none text-[22vw] leading-none">
          {title}
        </span>
        <div className="relative mx-auto max-w-[1400px]">
          <h1 className="font-display text-[13vw] font-black uppercase leading-[0.85] tracking-tighter text-foreground md:text-[7vw]">
            {title}
            <span className="text-primary">!</span>
          </h1>
          <div className="mt-10 h-px w-24 bg-primary" />
          <p className="body-copy mt-10 max-w-2xl text-lg text-foreground/70">
            {description ?? "Coming soon."}
          </p>
        </div>
      </section>
    </PageShell>
  );
}
